<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="auto">
        <b-button
          variant="primary"
          :to="'create-whitelist-blacklist'"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk("ClientPortal.management.Create") }}
        </b-button>
      </b-col>
    </b-row>
    <section>
      <b-card
        class="my-50 admin-table--management"
        no-body
      >
        <Table
          :data="formattedProperties"
          :columns="columns"
          :is-loading="isLoading"
          :class-names="{ 'table-row': 'spaced-row'}"
          class="admin-table__data"
          type-of-table="accountPropertyTargetingsData"
          @changePage="changeCurrentPage"
        />
      </b-card>
    </section>
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import Table from '@/components/Table.vue'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  name: 'WhitelistBlacklist',
  components: {
    Table,
    GjIcon,
  },
  setup() {
    const isLoading = ref(false)
    const currentPage = ref(1)
    const pageLength = 10

    const columns = ref([
      { label: 'Property Name', field: 'propertyName', width: '300px !important' },
      { label: 'WhiteList', field: 'whiteListNames', width: '400px !important' },
      { label: 'BlackList', field: 'blackListNames', width: '400px !important' },
    ])
    const changeCurrentPage = async newPage => {
      currentPage.value = newPage
      store.commit('SET_CURRENT_PAGE', newPage)
      const skip = (newPage - 1) * pageLength

      await store.dispatch('getAccountPropertiesTargetings', { skip, take: pageLength })
    }

    const tableData = computed(() => store.getters.allPropertiesAccountTargetings)

    const formattedProperties = computed(() => ({
      pageLength,
      totalRecords: tableData.value.totalRecords,
      searchTerm: '',
      currentPage: currentPage.value,
      rows: tableData.value.rows,
    }))

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getAccountPropertiesTargetings', { skip: 0, take: pageLength })
      isLoading.value = false
    })

    return {
      isLoading,
      formattedProperties,
      changeCurrentPage,
      columns,
    }
  },
}
</script>
